const request = {}

request.createRequest = function (customerCategoryData) {
  return {
    name: customerCategoryData.name,
    sortNumber: customerCategoryData.sortNumber,
    isEnabled: customerCategoryData.isEnabled
  }
}
export default { request }
